import { combineReducers } from 'redux';
import {
  FETCH_ZONES_CHOICE,
  FETCH_ZONES_CHOICE_SUCCESS,
} from '../actions/zonesRef';

const all = (state = [], action) => {
  switch (action.type) {
    case FETCH_ZONES_CHOICE:
      return state;
    case FETCH_ZONES_CHOICE_SUCCESS:
      return [...state, action.choices];
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_ZONES_CHOICE:
      return true;
    case FETCH_ZONES_CHOICE_SUCCESS:
      return false;
    default:
      return state;
  }
};

const zonesRef = combineReducers({
  all,
  isFetching,
});

export default zonesRef;

export const getIsFetching = state => state.manips.zonesRef.isFetching;

export const getZonesRef = state => state.manips.zonesRef.all[0];



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/zonesRef.js